import { FormatService } from 'services/FormatService'
import { log } from 'utils/Logger'

let mockJson = null
let mockCurrentLength = null

function clearMock() {
  mockJson = null
  mockCurrentLength = null
  const input = document.getElementById('mockJson')
  clearFileInput(input)
}

function clearFileInput(ctrl) {
  try {
    ctrl.value = null
  }
  catch (ex) {
    // eslint-disable-next-line no-empty
  }
  if (ctrl.value) {
    ctrl.parentNode.replaceChild(ctrl.cloneNode(true), ctrl)
  }
}

export function initMockResponse() {
  let input = document.createElement('input')
  input.setAttribute('id', 'mockJson')
  input.type = 'file'
  document.body.prepend(input)
  input.style.position = 'absolute'
  input.onchange = (event) => {
    let uploadedFile = event.target.files[0]
    if (uploadedFile.type !== 'application/json') {
      alert('Wrong file type == ' + uploadedFile.type)
      return false
    }

    if (uploadedFile) {
      let readFile = new FileReader()
      readFile.onload = function (e) {
        let contents = e.target.result
        mockJson = JSON.parse(contents)
        mockCurrentLength = 0
      }
      readFile.readAsText(uploadedFile)
    }
    else {
      log('Failed to load Mock file')
    }
  }
}

function parse(data) {
  if (data === undefined) {
    log('data from server undefined ', 'WARNING')
    return
  }
  const models = game.models
  models.ResponseDataModel.set(data)

  if (mockJson) {
    if (mockCurrentLength <= mockJson.length - 1) {
      data.context = mockJson[mockCurrentLength]
      mockCurrentLength++
    }
    else {
      clearMock()
    }
  }

  //user
  models.BalanceModel.set(data.user.balance)
  models.GameModel.I18n = data.user.i18n || data.user.lang
  models.GameModel.currency = data.user.currency || 'USD'
  FormatService.init(data.user)

  //settings
  if (data.settings) {
    models.SpinModel.setSettings(data.settings)

    if (
      data.settings.integration &&
      data.settings.integration.hasOwnProperty('blockGameOnError')
    ) {
      game.models.GameModel.blockGameOnError =
        data.settings.integration.blockGameOnError
    }

    models.BetModel.setList(
      data.settings.bets.map((x) => x * models.SpinModel.get().lines),
    )
    models.BetModel.setValue(data.context.bet * models.SpinModel.get().lines)
    models.AutoCountModel.setList(data.settings.autoplay.count)
    models.AutoLimitModel.setAutoLimits(data.settings.autoplay.limits)
    models.CascadeModel.checkIsCascade(data.settings)
    models.PayoutModel.setList(
      data.settings.paytable,
      Object.keys(data.settings.lines).length,
    )
    models.GameModel.gameType = data.settings.type
    models.GameModel.RTP = data.settings.rtp
    models.GameModel.integrationPostMessageEvents = data.extras?.integrationPostMessageEvents || {}

    if (data.settings.jurisdiction) {
      models.JurisdictionModel.set(data.settings.jurisdiction)
    }

    if (!data.settings.gamble) {
      delete data.context.win
    }
  }
  //context -- todo
  models.SpinModel.set(data)
  models.CascadeModel.set(data.context)
  models.GambleModel.set(data)
  models.WinModel.set(data.context)
  models.FreespinModel.set(data.context)
  models.FreebetsModel.set(data.context)
  //todo privet kak dela
  return true
}

export function getResponseParseService() {
  return { parse }
}
